<div class="modal-header">
  <p class="modal-title"><strong>{{ activity?.header }}</strong></p>
  <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>
</div>
<form name="form" #f="ngForm" (ngSubmit)="sendMail(f)">
  <div class="modal-body mail-body activityemail">
    <div class="col-12 mb-3">
      <div class="row">
        <div class="col-sm-1"><label class="form-label">To</label></div>
        <div class="col-sm-11">
          <ng-select name="toAddresses" [items]="toAdUsers | async" [typeahead]="tosearchInput$"
            bindLabel="userPrincipalName" bindValue="userPrincipalName" [(ngModel)]="tos" #toAddresses="ngModel"
            [ngClass]="{ 'is-invalid': f.submitted && (!tos || tos.length === 0) }" placeholder="Select item"
            [loading]="toShowLoader" [multiple]="true" required>
            <ng-template ng-option-tmp let-item="item">
              <div><span>{{item.displayName}}</span></div>
              <div><span><small>{{item.userPrincipalName}}</small></span></div>
            </ng-template>
          </ng-select>
          <div *ngIf="f.submitted && (!tos || tos.length === 0)" class="invalid-feedback">
            To address is required
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 mb-3">
      <div class="row">
        <div class="col-sm-1"><label>Cc</label></div>
        <div class="col-sm-11">
          <ng-select name="cc" [items]="ccAdUsers | async" [typeahead]="ccsearchInput$" bindLabel="userPrincipalName"
            bindValue="userPrincipalName" [(ngModel)]="ccs" placeholder="Select item" [loading]="ccShowLoader"
            [multiple]="true">
            <ng-template ng-option-tmp let-item="item">
              <div><span>{{item.displayName}}</span></div>
              <div><span><small>{{item.userPrincipalName}}</small></span></div>
            </ng-template>
          </ng-select>
        </div>
      </div>
    </div>
    <div class="col-12 mt-3 mb-3">
      <div class="row">
        <div class="col-sm-1"><label>Subject</label></div>
        <div class="col-sm-11">
          <input type="text" class="form-control form-control-sm" name="subject" [(ngModel)]="results.subject"
            #subject="ngModel" [ngClass]="{ 'is-invalid': f.submitted && subject.invalid }" required />
          <div *ngIf="f.submitted && subject.invalid" class="invalid-feedback">
            <div *ngIf="subject.errors?.required">Subject is required</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 mt-3 mb-3" *ngIf="results.activityTemplates?.length > 1">
      <div class="row">
        <div class="col-sm-1"><label>Templates</label></div>
        <div class="col-sm-11">
          <select name="activityTemplateId" class="form-select form-select-sm" (change)="TemplateLoad($event)"
            [(ngModel)]="results.activityTemplateId" #activityTemplateId="ngModel" required>
            <option *ngFor="let temp of results.activityTemplates" [value]="temp.id">{{temp.name}}</option>
          </select>
        </div>
      </div>
    </div>

    <div class="col-12 mt-3 mb-3">
      <label>Attachments</label>
      <div class="d-flex flex-wrap align-items-center">
        <div *ngFor="let doc of results.attachments; let i = index"
          class="attachment m-1 d-flex w-auto p-1 justify-content-between align-items-center">
          <div class="d-flex align-items-center" style="min-width: 0;">
            <div class="ms-2">
              <img src="design/images/paperclip.png" style="width: 20px;height:20px" alt="attachment">
            </div>
            <div class="mx-2 text-white text-break">{{doc | replace }}</div>
          </div>
          <a class="ms-2 flex-shrink-0" (click)="removeTemplateAttachment(i)">
            <img src="design/images/cancel.png" style="width: 10px;height:10px" alt="remove">
          </a>
        </div>

        <div *ngFor="let doc of uploadedFiles; let i = index"
          class="attachment m-1 d-flex w-auto p-1 justify-content-between align-items-center">
          <div class="d-flex align-items-center" style="min-width: 0;">
            <div title="Download" class="ms-2" (click)="downloadAttachment(doc)">
              <img src="design/images/paperclip.png" class="cursor-pointer" style="width: 20px;height:20px"
                alt="attachment">
            </div>
            <div class="mx-2 text-white text-break">{{doc.fileName | replace }}</div>
          </div>
          <a class="ms-2 flex-shrink-0" (click)="deleteAttachment(doc)">
            <img src="design/images/cancel.png" class="cursor-pointer" style="width: 10px;height:10px" alt="remove">
          </a>
        </div>

        <div class="ms-3 fw-bold text-muted"
          *ngIf="(!results.attachments || results.attachments.length === 0) && (!uploadedFiles || uploadedFiles.length === 0)">
          No attachments available
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-md-8 mb-3 ms-3">
          <label class="form-label">Attach existing documents</label>
          <div class="input-group mb-3">
            <ng-select class="flex-grow-1" name="existingDocs" [items]="existingDocs" bindLabel="documentName"
              [(ngModel)]="selectedExistingDocs" [multiple]="true" placeholder="Select uploaded document(s)">
              <ng-template ng-option-tmp let-item="item">
                <span>{{item.documentName}}</span> <small class="text-muted"> ({{item.fileName | replace}})</small>
              </ng-template>
            </ng-select>
            <button type="button" [disabled]="!selectedExistingDocs || selectedExistingDocs.length === 0"
              (click)="attachSelectedExistingDocs()" class="btn btn-secondary btnAttach">Attach</button>
          </div>
        </div>
      </div>

      <div class="row">
        <form name="uform" class="needs-validation col-md-8 mb-3 ms-3" #u="ngForm" novalidate>
          <label class="form-label">Attach file</label>
          <div class="input-group mb-3">
            <input id="fileControl" [disabled]="disableUpload" #fileControl name="fileName" [(ngModel)]="fileName"
              type="file" (change)="fileSelected($event.target.files)" [accept]="fileBrowserAllowedTypes"
              style="display: none;">
            <input id="fileField" type="text" class="form-control form-control-sm readonly-date" readonly
              [value]="selectedFileName" />
            <button type="button" [disabled]="disableUpload" (click)="browseFile()"
              class="btn btn-outline-primary">Browse</button>
            <button type="button" [disabled]="!selectedDocument || disableUpload" (click)="uploadDoc()"
              class="btn btn-secondary btnAttach">
              <span *ngIf="!disableUpload">Attach</span>
              <span *ngIf="disableUpload" class="spinner m-3 reset-spinner-left"></span>
            </button>
          </div>
        </form>
      </div>
    </div>

    <div class="col-12 mt-3">
      <label>Message</label>
      <editor name="email" [init]="toolbarConfig" [(ngModel)]="results.content"></editor>
    </div>

    <div class="col-12 text-center mt-3 mb-3">
      <button class="btn btn-outline-primary me-2" [disabled]="disableUpload || isDisabled" (click)="modal.dismiss()"
        onclick="javascript:return false;">Close</button>
      <button type="button" (click)="saveMailAsDraft(f)" class="btn btn-outline-primary me-2"
        [disabled]="isDisabled">Save as draft</button>
      <button class="btn btn-secondary" type="submit" [disabled]="isDisabled">Submit</button>
    </div>
  </div>
</form>
